/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytTercTo } from '../../models/teryt-terc-to';

export interface ApiWebTerytWojewodztwaWojPowiatyPowGminyGet$Params {
  pow: string;
  woj: string;
  date?: LocalDate;
}

export function apiWebTerytWojewodztwaWojPowiatyPowGminyGet(http: HttpClient, rootUrl: string, params: ApiWebTerytWojewodztwaWojPowiatyPowGminyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TerytTercTo>>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytWojewodztwaWojPowiatyPowGminyGet.PATH, 'get');
  if (params) {
    rb.path('pow', params.pow, {});
    rb.path('woj', params.woj, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TerytTercTo>>;
    })
  );
}

apiWebTerytWojewodztwaWojPowiatyPowGminyGet.PATH = '/api/web/teryt/wojewodztwa/{woj}/powiaty/{pow}/gminy';
